import Vue from 'vue'
import Element from 'element-ui'
import xhr from 'service'
import Component from 'vue-class-component'
import { copyToClipboard } from 'service/utils'

@Component({
    props: {
        classname: String,
        styles: Object
    }
})

export default class VueComponent extends Vue {

    hasClass(obj, cls){
        return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
    }

    addClass(obj, cls) {
        if (!hasClass(obj, cls)) obj.className += ' ' + cls;
    }

    removeClass(obj, cls) {
        if (hasClass(obj, cls)) {
            const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
            obj.className = obj.className.replace(reg, ' ');
        }
    }

    notify(message, type){
        return Element.Notification({  // Notification
            type: type || 'success',
            message: message,
            duration: 2000,
            customClass: 'custom-notify',
        })
    }

    fetch(url, params){
        return xhr.fetch(url, params)
    }
    copyHandle(text){
        copyToClipboard(text).then(res =>{
            this.$notify({
                title: '成功',
                message: '复制成功',
                type: 'success',
                position: 'bottom-right'
            })
        },data =>{
            this.$notify({
                title: '失败',
                message: data,
                type: 'error',
                position: 'bottom-right'
            })
        })
    }
}

export { Component }


// WEBPACK FOOTER //
// ./src/components/BaseVue.js